exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "table.jobble-table.receipts th:first-child,table.jobble-table.receipts th:nth-child(2){min-width:200px}table.jobble-table.receipts th:nth-child(3){min-width:150px}table.jobble-table.receipts tr td:nth-child(4){font-size:14px}table.jobble-table.receipts th:nth-child(5){min-width:100px}table.jobble-table.receipts th:nth-child(6){min-width:130px}table.jobble-table.receipts tr td:nth-child(6) a{font-size:14px}table.jobble-table.receipts tbody.not-real-jobs-body tr.fake-jobs td{background:linear-gradient(270deg,#f3f3f2,#e2e3e2);background-position:0;animation-timing-function:ease-in-out;background-size:200%;animation:myfirst 1s;-moz-animation:myfirst 1s infinite;-webkit-animation:myfirst 1s infinite;height:53px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/app/components/transactionhistory/transactionhistory.css
// module id = 451
// module chunks = 0